import { createApiRef } from '@backstage/frontend-plugin-api';
import type {
  FindingDetail,
  CollectionRun,
  FindingDataSelection,
  FindingListQuery,
  FindingListResponse,
  RepositoryScope,
  AssessmentSelection,
  AssessmentPreview,
  AssessmentRun,
  HumanReviewInput,
} from '@internal/plugin-dependency-security-common';

export interface DependencySecurityApi {
  saveHumanReview(id: string, input: HumanReviewInput): Promise<void>;
  revokeHumanReview(id: string, reviewId: string): Promise<void>;
  getFindings(query?: FindingListQuery): Promise<FindingListResponse>;
  getFinding(
    id: string,
    selection?: FindingDataSelection,
  ): Promise<FindingDetail>;
  getRepositories(): Promise<RepositoryScope>;
  getLatestCollectionRun(): Promise<CollectionRun | null>;
  startCollection(repository: string): Promise<CollectionRun>;
  previewAssessment(selection: AssessmentSelection): Promise<AssessmentPreview>;
  startAssessment(selection: AssessmentSelection): Promise<AssessmentRun>;
  getLatestAssessmentRun(
    selection: AssessmentSelection,
  ): Promise<AssessmentRun | null>;
}

export const dependencySecurityApiRef =
  createApiRef<DependencySecurityApi>().with({
    id: 'plugin.dependency-security.api',
  });
